import { ChangeDetectorRef, Component } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';

import { filterBoolean } from '@recruitee/common';
import {
  CompanyVerificationRequestStatus,
  SpamVerificationActions,
} from '@recruitee/spam-verification-data';
import { SpamVerificationService } from '@recruitee/spam-verification-logic';
import { SpamVerificationStatusInfoboxComponent } from '@recruitee/spam-verification-ui';
import { LifeCycle } from '@recruitee/utils';

@Component({
  selector: 'rt-spam-verification-infobox-container',
  template: `
    @if (companyVerificationRequestStatus) {
      <rt-spam-verification-status-infobox
        [status]="companyVerificationRequestStatus"
      ></rt-spam-verification-status-infobox>
    }
  `,
  styleUrls: ['./spam-verification-infobox-container.component.less'],
  imports: [SpamVerificationStatusInfoboxComponent],
})
export class SpamVerificationInfoboxContainerComponent {
  public companyVerificationRequestStatus: CompanyVerificationRequestStatus;

  @LifeCycle('onDestroy')
  private ngOnDestroy$: Subject<void>;

  constructor(
    private service: SpamVerificationService,
    private store: Store,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit() {
    this.service.verificationRequired$
      .pipe(
        filterBoolean,
        tap(() => {
          this.store.dispatch(SpamVerificationActions.fetch());
        }),
        switchMap(() => this.service.selectSpamVerificationStatus$),
        takeUntil(this.ngOnDestroy$),
      )
      .subscribe(status => {
        this.companyVerificationRequestStatus = status;
        this.cdRef.detectChanges();
      });
  }
}
